/*
 * @Author: 晋枫
 * @Date: 2021-09-17 13:35:10
 * @LastEditTime: 2021-09-27 21:02:24
 * @LastEditors: 晋枫
 * @Description:
 * @FilePath: /jmj-7v1-task/src/router/modules/bulletinBoard/normal.js
 * 🍁YOU CAN（NOT）REDO🍁
 */
import { routeAddWorkOrderId, WORK_ORDER_TYPES } from '@/views/wxapp/bulletin-board/workbench-v2/constant'

const normalRouter = [
  {
    path: 'normal-kan-ban',
    name: 'NormalKanBan',
    component: () => import('@/views/wxapp/bulletin-board/management/factor-bar'),
    meta: {
      title: ''
    },
    children: [
      {
        path: 'currency-details',
        name: 'CurrencyDetails',
        component: () => import('@/views/wxapp/bulletin-board/currency-module/details/index'),
        meta: {
          title: ''
        }
      },
      {
        path: 'normal',
        name: 'Normal',
        component: () => import('@/views/wxapp/bulletin-board/currency-module/normal'),
        meta: {
          title: ''
        }
      }
    ]
  },
  {
    path: 'income-expense',
    name: 'IncomeExpense',
    component: () => import('@/views/wxapp/bulletin-board/currency-module/income-expense'),
    meta: {
      title: ''
    }
  }
]

export default routeAddWorkOrderId(normalRouter, WORK_ORDER_TYPES.OPERATE)
